module.exports = __webpack_public_path__ + "static/media/revlon4.76f55b85.jpg";